<script lang="tsx">
  import { Skeleton } from "primevue";
  import Figure from "./Figure.vue";

  export default {
    components: { Skeleton, Figure },
    props: Figure.props as (typeof Figure["props"]),
  };
</script>

<template>
  <Suspense>
    <Figure v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <Skeleton width="100%" height="8em"/>
    </template>
  </Suspense>
</template>
